import { useState } from "react";
import { Link } from "react-router-dom";

const MenuOverlay = ({ open, MenuClass }) => {

    //let translate = open ? 'translate-y-0' : 'translate-y-full';
    return (
        <div className={`menu-overlay ${MenuClass}  min-w-full h-full bg-black-300 z-10 fixed overflow-hidden inset-0`}>
            <div className="container mx-auto px-4 mt-[50%]">
                <div className="flex flex-col justify-center">
                    <Link className="text-white text text-xl" to="/">Home</Link>
                    <Link className="text-white text mt-7 text-xl" to="/">Catalog</Link>
                    <Link className="text-white text mt-7 text-xl" to="/">Top anime</Link>
                    <Link className="text-white text mt-7 text-xl" to="/">Mi list</Link>
                </div>
            </div>
        </div>
    )
}



const Hamburg = () => {
    const [open, setopen] = useState(false);

    const handlerOpenMenu = () => {
        setopen(!open);
    }
    let MenuClass = open ? 'menu-open' : 'menu-close';
    return (
        <>
            <div className={`menu z-20`}>
                <div className="list-menu hidden md:flex  flex-row items-center justify-between">
                    <Link className="text-gray-300 p-4  hover:underline" to="/">item</Link>
                    <Link className="text-gray-300 p-4  hover:underline" to="/">item</Link>
                    <Link className="text-gray-300  p-4 hover:underline" to="/">item</Link>
                </div>
                <div className={`${MenuClass} md:hidden hover:cursor-pointer z-20`}>
                    <svg width="36" height="24" viewBox="0 0 36 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={handlerOpenMenu} className='my-2'>
                        <rect className='top-menu fill-gray-300' width="100%" height="2.70769" />
                        <rect className='middle-menu fill-gray-300' height="2.70769" width="100%" x="0" y="10" rx="1.35385" />
                        <rect className='bottom-menu fill-gray-300' x="0" y="20" width="100%" height="2.70769" rx="1.35385" />
                    </svg>
                </div>
            </div>
            <MenuOverlay open={open} MenuClass={MenuClass} />
        </>
    )
}

export default Hamburg;